import { FC, useState } from 'react';
import { ICurrentTabProps } from '../../types';
import AddIcon from '@mui/icons-material/Add';
import BookmarkAdd from '@mui/icons-material/BookmarkAdd';
import { Check } from '@mui/icons-material';
import { Sheet, Typography, Select, Option, Button, Tooltip, TextField } from '@mui/joy';
import { addCurrentTabToList, addNewCategory } from '../../controllers/currentTabData';
import { useUserDataContext, useUserDataDispatchContext } from '../../LinkDataStore/Context';
import { extractURLDomain } from '../../controllers/userDataController';
import { useSnackbarDispatch } from '../../SnackbarDataStore/Context';
import { setSnackbar } from '../../controllers/snackController';

const CurrentTabData: FC<ICurrentTabProps> = ({ urlData }) => {

	const userDataDispatch = useUserDataDispatchContext();
	const [addCategory, setAddcategory] = useState(false);
	const snackbarDispatch = useSnackbarDispatch();
	const userDataState = useUserDataContext();
	const [newCategoryName, setNewCategoryName] = useState("");
	const [selectedCategory, setSelectedCategory] = useState(userDataState.defaultCategoryKey);


	async function handleAddBookmark() {
		let inserted = false;
		if (selectedCategory === '') {
			inserted = await addCurrentTabToList(userDataDispatch, urlData, userDataState.defaultCategoryKey);
		} else {
			inserted = await addCurrentTabToList(userDataDispatch, urlData, selectedCategory);
		}

		if (inserted) {
			setSnackbar(snackbarDispatch, "Link added!!!", "success");
		} else {
			setSnackbar(snackbarDispatch, "Something went wrong :(", "error");
		}
	}

	async function handleNewCategoryAddToggle() {
		if (addCategory) {
			if (newCategoryName !== "") {
				const added = await addNewCategory(userDataDispatch, newCategoryName);
				if (added) {
					setSnackbar(snackbarDispatch, "New category added", "success");
				} else {
					setSnackbar(snackbarDispatch, "Something went wrong :(", "error")
				}
			}
		} else {
			setNewCategoryName("");
		}

		setAddcategory(!addCategory);
	}

	return (
		<>
			<Sheet
				sx={{
					width: "100%",
					padding: "5px 20px",
					position: "sticky",
					top: "0px",
					zIndex: "10",
				}}
			>
				<div className='p-3 border border-blue-900 rounded-lg flex items-center justify-between'>
					<div>
						<Typography noWrap={false} level='h6'>{(urlData.title.length > 50) ? urlData.title.substring(0, 47) + "..." : urlData.title}</Typography>
						<Typography noWrap={false} level='body3'>{extractURLDomain(urlData.url)}</Typography>
					</div>
				</div>
				<div className='my-2 grid grid-cols-12 gap-4'>
					{!addCategory ? <Select defaultValue={userDataState.defaultCategoryKey} onChange={(e, newValue) => setSelectedCategory("" + newValue)} className='col-span-8' placeholder="Choose One...">
						{
							userDataState.data.map((element) => {
								return (
									<Option value={element._id} key={element._id}>{element.tagName}</Option>
								)
							})
						}
					</Select> : <TextField className="col-span-8" value={newCategoryName} onChange={(e) => setNewCategoryName(e.target.value)} />}
					<Tooltip variant='outlined' arrow color='primary' title={!addCategory ? "Add new category" : "Save category"}>
						<Button variant='outlined' className='col-span-2' onClick={handleNewCategoryAddToggle}>
							{!addCategory ? <AddIcon /> : <Check />}
						</Button>
					</Tooltip>
					<Tooltip variant='outlined' arrow color='primary' title="Save Bookmark">
						<Button className='col-span-2' variant='solid' onClick={handleAddBookmark}>
							<BookmarkAdd />
						</Button>
					</Tooltip>
				</div>
			</Sheet>
		</>
	)
}

export default CurrentTabData;